// extracted by css-extract-rspack-plugin
export default {"dbCard":"BrowseDatabases-module__dbCard___vpC1K","addCard":"BrowseDatabases-module__addCard___Ldx6H"};